import styled, { keyframes } from "styled-components";

import { isAutoscaleType } from "./../utils";

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const ActivityLine = styled.rect`
  animation: 0.1s linear 1 ${fadeIn};
  ${({ activityType }) =>
    isAutoscaleType(activityType)
      ? `fill: var(--theme-warning-600);`
      : `fill: var(--theme-neutral-200);`}

  cursor: pointer;
  ${({ someActive, isActive }) =>
    someActive && isActive ? "fill:var(--icon-slate-fill,var(--slate))" : ""};

  ${({ someActive, isActive }) =>
    someActive && !isActive ? `opacity: 0.3;` : ""};
`;

export const ActivityCircle = styled.circle``;
